import React, { ReactNode } from "react";
import styles from "./ticket_integration.module.scss";

interface ITicketResponse {
    error: boolean;
    message: ReactNode | string;
    ticket?: string;
}

export const parseTicketResponse = (res: string, t: any, isExternal: boolean, url?: string, errorPrefix?: string): ITicketResponse => {
    const trackerUrl = url ? url : "https://st.yandex-team.ru/";
    let isError = false;
    let message: string | ReactNode;
    let ticket: string | undefined;
    try {
        const errorObj = JSON.parse(res);
        isError = true;
        const backendMessage = errorObj.message;
        const isTrackerUnavailable = typeof backendMessage === "string" &&
            /(?:^|\s)(?:ru|u)\.yandex\.startrek\.client\.error\.StartrekInternalServerError(?=:|\s|$)/.test(backendMessage);
        message = isTrackerUnavailable ? t("trackerUnavailable") :
            errorPrefix ? `${errorPrefix} ${backendMessage}` : backendMessage;
    } catch (e) {
        // if object is not parsed, ticket is correct
        const [key, ticketNumber] = res.split(" ");
        let translate;
        ticket = ticketNumber;
        try {
            // @ts-ignore
            translate = t(key);
        } catch (e) {
            translate = ""
        }
        message = isExternal ?
            <div className={styles.toast}>{t("thanksDataSend")}</div>
            : <div className={styles.toast}>
                <span>{translate}</span>
                <a target="_blank" rel="noreferrer"
                   className={styles.link}
                   href={`${trackerUrl}${ticketNumber}`}>{ticketNumber}</a>
            </div>
    }

    return {
        error: isError,
        message,
        ticket
    }
}
